export default __webpack_public_path__ + "static/media/vk_small.705d82e5.svg";